import { useI18n } from '@i18n/i18n.utils';
import { DefaultActionsErrorView } from '../DefaultActionsErrorView/DefaultActionsErrorView';

export default function NotFoundView() {
  const { t } = useI18n();

  return (
    <DefaultActionsErrorView
      title={t('errorView.404.title')}
      subtitle={t('errorView.404.subtitle')}
      iconVariant="primary"
    />
  );
}
